export const resStates = {
    new: {
      icon: "asterisk"
    },
    saving: {
      icon: "spinner"
    },
    error: {
      icon: "warning sign"
    },
    saved: {
      icon: "save outline"
    }
  }